export const EMBED_MESSAGE_VERSION = 1;
export const MIN_EMBED_HEIGHT = 320;
export const MAX_EMBED_HEIGHT = 20000;

export const EMBED_EVENT_TYPES = Object.freeze([
  "ferasurvey:ready",
  "ferasurvey:resize",
  "ferasurvey:started",
  "ferasurvey:saved",
  "ferasurvey:submitted",
  "ferasurvey:authentication-required",
  "ferasurvey:unavailable",
  "ferasurvey:error",
]);

export const safeEmbedHeight = value => {
  const height = Math.round(Number(value));
  if (!Number.isFinite(height)) return null;
  return Math.min(MAX_EMBED_HEIGHT, Math.max(MIN_EMBED_HEIGHT, height));
};

export const createEmbedMessenger = ({
  embedId,
  correlationId,
  parentOrigin,
  targetWindow = window.parent,
}) => {
  if (!embedId || !/^https:\/\//i.test(parentOrigin || "") || !targetWindow) {
    return { send: () => false };
  }
  return {
    send(type, values = {}) {
      if (!EMBED_EVENT_TYPES.includes(type)) return false;
      const payload = {
        source: "ferasurvey",
        version: EMBED_MESSAGE_VERSION,
        type,
        embedId,
        ...(correlationId ? { correlationId } : {}),
      };
      if (type === "ferasurvey:resize") {
        const height = safeEmbedHeight(values.height);
        if (height === null) return false;
        payload.height = height;
      }
      targetWindow.postMessage(payload, parentOrigin);
      return true;
    },
  };
};

export const observeEmbedHeight = (
  root,
  messenger,
  Observer = window.ResizeObserver
) => {
  if (!root || !messenger) return () => {};
  let timer = null;
  const publish = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      const height = Math.max(
        root.scrollHeight || 0,
        root.getBoundingClientRect?.().height || 0
      );
      messenger.send("ferasurvey:resize", { height });
    }, 60);
  };
  publish();
  if (typeof Observer !== "function") {
    window.addEventListener("load", publish, { once: true });
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("load", publish);
    };
  }
  const observer = new Observer(publish);
  observer.observe(root);
  window.addEventListener("load", publish, { once: true });
  return () => {
    window.clearTimeout(timer);
    observer.disconnect();
    window.removeEventListener("load", publish);
  };
};
